import Dialog, { DialogProps } from '@mui/material/Dialog';

// ---------------------------------------------------------------------------

export const CustomDialogContainer = ({ children, sx, open, onClose, ...res }: DialogProps) => {
  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          border: (theme) => `1px solid ${theme.palette.background.border}`,
          backgroundColor:  (theme) => `${theme.palette.background.secondary} !important`
        }
      }}
      sx={{
        '& .MuiPaper-root.MuiDialog-paper': {
          backgroundColor: (theme) => theme.palette.background.secondary,
        },
        ...sx,
      }}
      {...res}
    >
      {children}
    </Dialog>
  );
};
